import { ExclamationCircleIcon } from '@heroicons/react/24/solid'
import { type FC } from 'react'
import { type DefaultProps } from '../common'

export interface GenericErrorProps extends DefaultProps {
  errorMessage: string
}

export const GenericError: FC<GenericErrorProps> = ({
  // Common default properties for each component
  className,
  id,
  testId,
  ariaLabel,
  children,
  errorMessage,
}) => {
  return (
    <div
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <ExclamationCircleIcon className="fill-alert-300 relative right-1 mb-2 h-12 w-12" />
      <p data-testid="generic-error-message" className="text-error text-2xl font-light">
        {errorMessage}
      </p>
      {children}
    </div>
  )
}
